// Centralized contact info — replace these with real numbers anytime.
export const CONTACT = {
  phone: "+919826044668",
  phoneDisplay: "+91 98260 44668",
  whatsapp: "919826044668",
  email: "hello@launchmitra.in",
};

export const waLink = (msg = "Hi Launch Mitra, I'd like to launch my business online.") =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(msg)}`;

export const telLink = () => `tel:${CONTACT.phone}`;
